import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { applyPrivateMeta } from "@/lib/site";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ShopProvider } from "@/lib/shop";
import Click2Home from "@/pages/Click2Home";
import LeadPortal from "@/pages/LeadPortal";
const Login = React.lazy(() => import("@/pages/Auth").then((x) => ({ default: x.Login })));
const ForgotPassword = React.lazy(() => import("@/pages/Auth").then((x) => ({ default: x.ForgotPassword })));
const ResetPassword = React.lazy(() => import("@/pages/Auth").then((x) => ({ default: x.ResetPassword })));
const VerifyEmail = React.lazy(() => import("@/pages/Auth").then((x) => ({ default: x.VerifyEmail })));
const PaymentSuccess = React.lazy(() => import("@/pages/Subscribe").then((x) => ({ default: x.PaymentSuccess })));
const PartnerLanding = React.lazy(() => import("@/pages/PartnerLanding"));
const PartnerLogin = React.lazy(() => import("@/pages/PartnerLogin"));
const PartnerPortal = React.lazy(() => import("@/pages/PartnerPortal"));
const ReclamoVolo = React.lazy(() => import("@/pages/ReclamoVolo"));
const PaymentCancel = React.lazy(() => import("@/pages/Subscribe").then((x) => ({ default: x.PaymentCancel })));
const Crm = React.lazy(() => import("@/pages/Crm"));
const Collabora = React.lazy(() => import("@/pages/Collabora"));
const ResellerDashboard = React.lazy(() => import("@/pages/ResellerDashboard"));
import { api } from "@/lib/api";
import { AdsTracking } from "@/components/AdsTracking";

if ("scrollRestoration" in window.history) window.history.scrollRestoration = "manual";

const ScrollToTop = () => {
  const { pathname, search, hash } = useLocation();
  React.useLayoutEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, search, hash]);
  return null;
};

function PrivateMeta() {
  const { pathname } = useLocation();
  React.useEffect(() => { const t = setTimeout(() => applyPrivateMeta(pathname), 0); return () => clearTimeout(t); }, [pathname]);
  return null;
}

function RefCapture() {
  React.useEffect(() => {
    const ref = new URLSearchParams(window.location.search).get("ref");
    if (ref && localStorage.getItem("cs_ref") !== ref.toUpperCase()) {
      localStorage.setItem("cs_ref", ref.toUpperCase());
      api.post("/ref/click", { code: ref }).catch(() => {});
    }
  }, []);
  return null;
}

function App() {
  return (
    <ShopProvider>
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <AdsTracking />
        <Toaster position="top-center" richColors theme="dark" />
        <RefCapture />
        <PrivateMeta />
        <React.Suspense fallback={<div className="min-h-screen bg-[#0b0b10]" />}>
        <Routes>
          <Route path="/" element={<Click2Home />} />
          <Route path="/amministrazione/storefront/crmcorsi/crm/corsi/sip/crm" element={<Crm />} />
          <Route path="/operatori/customer/service/libro/coperico/mozart/v20" element={<Crm mode="operator" />} />
          <Route path="/collab/res/v1" element={<ResellerDashboard />} />
          <Route path="/collabora" element={<Collabora />} />
          <Route path="/partner" element={<PartnerLanding />} />
          <Route path="/partner/login/:slug" element={<PartnerLogin />} />
          <Route path="/partner/portale" element={<PartnerPortal />} />
          <Route path="/partner/customer/service/lead/coperico/mozart/v20agency" element={<LeadPortal />} />
          <Route path="/login" element={<Login />} />
          <Route path="/password-dimenticata" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verifica-email" element={<VerifyEmail />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/reclamovolo/assistenza/volo/:token" element={<ReclamoVolo />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </React.Suspense>
      </BrowserRouter>
    </AuthProvider>
    </ShopProvider>
  );
}

export default App;
